import { TranscriptExtension } from './types';
import { Word } from '@/player-config/src/types/transcript-types';

export const CURRENT_SELECTION_DEFAULT = {
  x: 0,
  y: 0,
  bottom: 0,
  right: 0,
  words: [] as Word[],
  startIndex: 0,
  endIndex: 0
};

export const CLIP_MIN_LENGTH = 3;
export const TRANSCRIPT_VIRTUOSO_COMPONENT_ID = 'TRANSCRIPT_VIRTUOSO_COMPONENT_ID';
export const TRIM_POSITION_OFFSET = 60;
export const CLIP_MIN_DURATION = 5;
export const CLIP_MIN_DURATION_ERROR = 'Min. 5 seconds';
export const CLIP_MAX_DURATION = 10800;
export const CLIP_MAX_DURATION_ERROR = 'Max. 3 hours';
export const HOOK_MIN_DURATION_IN_SECS = 2;
export const HOOK_BUTTON_WIDTH_IN_PX = 32;

export const TRANSCRIPT_SEARCH_DEBOUNCE = 700;

export const TRANSCRIPT_MAX_WORD_EDIT_LENGTH = 5;

export const TRANSCRIPT_PAUSE_THRESHOLDS = {
  microPause: 0.4,
  longPause: 1.0,
  deadSpace: 1.5
} as const;

export const SPEAKER_PACE_ANALYSIS = {
  // Ignore bigger gaps so cadence is measured from natural speech rhythm.
  maxCadenceGap: 0.5,
  slowAvgGapThreshold: 0.12,
  fastAvgGapThreshold: 0.07
} as const;

// Pause duration targets by speaker speed (seconds)
// Based on broadcast/podcast editing standards:
// - Intra-sentence gaps: near-zero to 200ms natural
// - Clause breaks: 200-400ms in natural speech
// - Sentence breaks: 300-500ms broadcast standard
// - Paragraph/topic shifts: 500-800ms edited content
export const SPEAKER_PACE_TARGETS = {
  slow: {
    microPause: 0.28,
    normalPause: 0.42,
    longPause: 0.65,
    deadSpace: 1.0
  },
  normal: {
    microPause: 0.2,
    normalPause: 0.35,
    longPause: 0.5,
    deadSpace: 0.8
  },
  fast: {
    microPause: 0.15,
    normalPause: 0.25,
    longPause: 0.4,
    deadSpace: 0.65
  }
} as const;

export const MIN_OPTIMIZATION_PERCENT = 5;

// Fraction of the preserved pause placed before the delete vs after.
// 0.2 means 20% of the remaining silence is before the cut, 80% after.
export const PAUSE_PRESERVE_BEFORE_RATIO = 0.2;

export enum ClipTranscriptMode {
  Full,
  EditDuration,
  EditCaptions
}

export const DEFAULT_TRANSCRIPT_EXTENSION: TranscriptExtension = {
  startTime: 0,
  startSegmentId: ''
};
